// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appName: 'AI',
  appIconColor: '#40E0D0',
  mydocmaConfig : {
    apiUrl: 'https://api-test.edr-software.com/mydocma',
    clientUrl: 'https://mydocma-test.edr-software.com',
    appId: '4f9d4ef3-474b-4441-9fc9-5b310fe8d7a6'
  },
  authConfig : {
    clientId: 'mydocma.AI', // PIX
    scope: 'offline_access iam ai',
    oidc: false,
    issuer: 'https://api-test.edr-software.com/mydocma',
    redirectUri: 'https://ai-test.edr-software.com/auth/callback',
    requireHttps: false,
    responseType: 'code',
    ignoredUrls: [
      '//assets.edr-software.com',
      'https://assets.edr-software.com',
     ],
    logoutUrl: 'https://mydocma-test.edr-software.com/account/logout',
    postLogoutRedirectUri: ''

  },
  aiConfig:{
    apiUrl: 'https://node-test.edr-software.com/ai'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
